export default function APropos() {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/d1b826543e2802fbc481528c51cc9578.jpeg"
          alt="À propos KEIKI"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/40 to-transparent"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <div className="bg-white/20 backdrop-blur-2xl border border-white/30 rounded-[32px] p-10 sm:p-14 shadow-2xl">
            <h2 className="text-5xl sm:text-6xl font-serif text-white mb-8">
              À Propos
            </h2>
            
            <p className="text-xl sm:text-2xl text-white/95 leading-relaxed font-light mb-6">
              Keiki est un restaurant local à Moorea. Une cuisine généreuse, une terrasse agréable, un bar sur place, et une ambiance calme & conviviale.
            </p>
            
            <div className="flex items-center gap-3 text-white/90 text-lg">
              <span className="text-2xl">🌈</span>
              <span className="font-medium">Ouvert à tous — LGBTQ+ friendly</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}